import {z} from 'zod';
import {id} from '../global/globalModels';

export const userMeBookingFor = z.object({
    id: id,
    firstName: z.string(),
    lastName: z.string(),
    initials: z.string(),
    profileImage: z.string().nullable(),
    calendarNotification: z.boolean(),
    defaultCostCenter: z.string().nullable(),
});

export type UserMeBookingFor = z.infer<typeof userMeBookingFor>;
